/**
 * 思维导图
 */
import React from "react"
import { observer } from 'mobx-react-lite';
import EE from '@/common/event';

import Markmap from '@/components/markmap';
import { SVGPureIcon } from '@ui/svg-icon';

import "./index.scss"
import appLogger from "@public/log/monitor";

const MindmapV2 = observer((props = {}) => {
  let {
    className="",
    mindmap="",
    page=[],
    prompt="",
    title="",
    hideTip,
    wrapcls,
    showModalContorller=true
  } = props

  const svgRef = React.createRef();

  const prehandleMindmap = (mindmap) => {
    let ret = ""

    if(mindmap) {
      // mindmap = mindmap.replace(/\\n/g, "\n")
      mindmap = mindmap.replace(/\~/g, " ~ ")
      mindmap = mindmap.replace(/([\d]+)\*([\d]+)/g, "$1 * $2")
      mindmap = mindmap.replace(/(\n)[\s]+(#)/g, "$1$2")
      // mindmap = mindmap.replace(/(\n)[\s]+(\-)/g, "$1$2")
      mindmap = mindmap.replace(/\$.+\$/g, "")

      ret = mindmap
    }

    if(mindmap === false){
      return mindmap;
    }

    return ret
  }

  mindmap = prehandleMindmap(mindmap)

  const getMaxDepth = (root) => {
    let maxDepth = 0

    const updateDepth = (node) => {
      if(node?.depth > maxDepth) {
        maxDepth = node.depth
      }
      node?.children?.forEach(child => {
        if(child) {
          updateDepth(child)
        }
      })
    }

    if(root) {
      updateDepth(root)
    }

    return maxDepth
  }

  const foldLast = (root) => {
    if(!root) {
      return
    }

    if(getMaxDepth(root) <= 1) {
      return
    }

    const fold = (node) => {
      if(node?.children?.length) {
        let isFold = true
        node.children.forEach(child => {
          if(child?.children?.length) {
            isFold = false
          }
          fold(child)
        });
        if(isFold) {
          node.payload = {...node.payload, fold: 1}
        }
      } else {
        node.payload = {...node.payload, fold: 1}
      }
    }

    fold(root)
  } 

  const rescaleCircleSize = () => {
    setTimeout(() => {
      const circles = document.querySelectorAll(".mindmap-svg circle")
      circles?.forEach(circle => {
        circle.setAttribute("r", 4)
      })
    }, 0)
  }

  const showModal = () => {
    if(!showModalContorller) return
    EE.emit("mindmap:modal:show", {
      mindmap,
      page: [{title}]
    })
  }

  return (
    <div className={`js-guide-3 relative w-full min-w-144px ${className}`}>
      {
        mindmap ? 
        <>
          <div 
            className={`
              mindmap-content-wrap 
              rounded-8px px-[24px] pt-38px pb-[1px]
              border-width-1px border-primary-opacity border-opacity-6 ${wrapcls}
            `}
          >
            <div className={`w-full relative cursor-pointer pb-[60%] mb-38px`}>
              <Markmap
                value={mindmap} 
                className="w-full h-full mindmap-svg absolute z-0" 
                ref={svgRef} 
                onBeforeRender={foldLast}
                markviewConf={{
                  autoFit: true, 
                  zoom: false,
                  pan: false,
                  maxWidth: 250, 
                  fitRatio: 0.95, 
                  spacingVertical: 10, 
                  duration: 0 
                }}
                onRender={rescaleCircleSize}
              />
              <div 
                className="w-full h-full absolute z-1 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation()
                  showModal()
                }}>
              </div>
            </div>
            {
              showModalContorller ? 
              <div className="mindmap-extend-btn-wrap flex items-center justify-center mt-[5px] h-[32px] relative top-1px">
                <div className="w-[168px] h-[32px] cursor-pointer relative mindmap-extend-btn"
                  onClick={(e) => {
                    e.stopPropagation()
                    showModal()
                  }}>
                  <SVGPureIcon name="mindmap_extend_bg_v2" width={"100%"} height={"100%"} className="opacity-4 mindmap-extend-btn-bg absolute"/>
                  <div 
                    className={`absolute text-primary-opacity text-14px flex left-[24px] top-[8px] h-[16px]`}
                    >
                    <SVGPureIcon name="mindmap_full_v2" size={16} />
                    <div className={`ml-6px mt-[1px]`}>{"点击展开完整版"}</div>
                  </div>
                </div>
              </div> : null
            }
          </div>
          {
            mindmap && prompt && !hideTip
            ? (
              <div className="my-[8px] text-primary-opacity text-[14px]">以上是关于“{appLogger.getSubContent(page?.length ? page[0]?.title : prompt, 100, '...')}”的思维导图</div>
            )
            : null
          }
        </>
        : mindmap === false
        ? (
          <div 
            className={`
              mindmap-content-wrap 
              rounded-8px px-[24px] pt-38px pb-[1px]
              border-width-1px border-primary-opacity border-opacity-6
            `}
          >
            <div className="flex flex-col items-center justify-center w-full">
              <img src="https://p5.ssl.qhimg.com/t11098f6bcd371e6a5e651274f9.png" className="size-[100px]" />
              <div className="my-11px text-black text-opacity-50 text-[14px] leading-[20px]">思维导图生成失败</div>
            </div>
          </div>
        )
        : (
          <div 
            className={`
              mindmap-content-wrap 
              rounded-8px px-[24px] pt-38px pb-[1px]
              border-width-1px border-primary-opacity border-opacity-6
            `}
          >
            <div className="flex flex-col items-center justify-center w-full">
              <img src="https://p5.ssl.qhimg.com/t11098f6bcd371e6a5e651274f9.png" className="size-[100px]" />
              <div className="my-11px text-black text-opacity-50 text-[14px] leading-[20px]">思维导图生成中…</div>
            </div>
          </div>
        )
      }
    </div>
  )
});
export default MindmapV2;
